import module from 'usuario/module.js'
import template from './template.html'

export class UsuarioVinculoComponent {
  idUsuario = null
  busqueda = undefined

  constructor (EmpleadosEmpleadoVinculoPersonas, $state) {
    this.EmpleadosEmpleadoVinculoPersonas = EmpleadosEmpleadoVinculoPersonas
    this.$state = $state
  }

  $onInit () {
    this.buscando = true
    this.promise = this.EmpleadosEmpleadoVinculoPersonas.get('', this.idUsuario)
      .then((response) => (this.datos = response.data))
      .finally(() => (this.buscando = false))
  }

  seleccionar (nombre, apellidos, rfc) {
    if (!rfc) return
    this.nombre = nombre + ' ' + apellidos
    this.rfc = rfc
    this.EmpleadosEmpleadoAccesoVincularConfirmar = true
  }

  cerrar (completo) {
    this.EmpleadosEmpleadoAccesoVincularConfirmar = false
    if (completo) {
      this.$state.go('usuario',{}, {reload: true})
    }
  }

  buscar () {
    this.buscando = true
    this.datos = []
    if (this.busqueda.length) {
      this.EmpleadosEmpleadoVinculoPersonas.get(this.busqueda)
        .then((response) => (this.datos = response.data))
        .finally(() => (this.buscando = false))
    } else {
      this.EmpleadosEmpleadoVinculoPersonas.get('', this.idUsuario)
        .then((response) => (this.datos = response.data))
        .finally(() => (this.buscando = false))
    }
  }
}

module.component('usuarioVinculo', {
  controller: UsuarioVinculoComponent,
  template,
  bindings: {
    idUsuario: '<',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/vinculo/component.js